import {FC} from 'react';
import {Box, Button, Flex} from '@chakra-ui/react';
import {useT} from '@kcast-fe/core';
import {Modal} from 'ui-kit';

interface IProps {
  isOpen: boolean;
  title: string;
  body: string;
  confirmLabel?: string;
  variant?: 'danger' | 'normal';
  isLoading?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialogFC: FC<IProps> = ({
  isOpen,
  title,
  body,
  confirmLabel = 'Confirm',
  variant = 'normal',
  isLoading,
  onConfirm,
  onCancel
}) => {
  const {t} = useT();

  return (
    <Modal isOpen={isOpen} title={title} maxW={'420px'} onClose={onCancel}>
      <Box p={'16px 24px 0'}>
        <Box color={'{colors.textSecondary}'} mb={'24px'}>
          {body}
        </Box>
        <Flex justifyContent={'flex-end'} gap={'12px'}>
          <Button size={'md'} variant={'subtle'} disabled={isLoading} onClick={onCancel}>
            {t('actions.close')}
          </Button>
          <Button
            size={'md'}
            /* @ts-ignore */
            variant={variant === 'danger' ? 'danger' : 'solid'}
            loading={isLoading}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </Flex>
      </Box>
    </Modal>
  );
};

export const ConfirmDialog = ConfirmDialogFC;
